import { useAuth } from '../contexts/AuthContext';

export function LoginPage() {
    const { login, authError } = useAuth();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[#020873] px-4">
            {/* Le logo est blanc (pensé pour un fond sombre) : il doit rester sur le
                fond bleu marine de la page, pas sur la carte blanche ci-dessous. */}
            <img src="/logo-clippit.png" alt="Clippit" className="h-12 w-auto mb-6" />
            <div className="card max-w-sm w-full text-center">
                <h1 className="text-xl font-semibold text-[var(--color-text)] mb-1">Clippit AVV</h1>
                <p className="text-sm text-[var(--color-text-secondary)] mb-6">
                    Suivi des avant-ventes
                </p>

                {authError && (
                    <p className="text-sm text-[var(--color-error)] bg-[var(--color-error-light)] rounded-lg px-3 py-2 mb-4">
                        {authError}
                    </p>
                )}

                <button onClick={login} className="btn-primary w-full">
                    Se connecter avec Microsoft
                </button>
            </div>
        </div>
    );
}
